//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {ThemeProvider} from '@emotion/react';
import {createTheme, CssBaseline} from '@mui/material';
import {isMobileDevice} from 'common';
import {Route, Routes} from 'react-router-dom';
import {desktop_light_theme, mobile_light_theme} from 'theme';
import HomePage from './HomePage';
import './root.css';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
export default function AppRoot() {
	const outer_theme = createTheme(isMobileDevice() ? mobile_light_theme : desktop_light_theme);

	return (
		<ThemeProvider theme={outer_theme}>
			<CssBaseline />

			<Routes>
				<Route path="/" element={<HomePage />} />
			</Routes>
		</ThemeProvider>
	);
}
